import React from 'react';
import { Navigate, useLocation } from "react-router-dom";

function LoggedInRoute(props) {
  const location = useLocation();

  if (props.userData.id) {
    return props.children;
  }

  return (
    <Navigate
      to="/login"
      state={{ from: location }}
      replace
    />
  );
}

export default LoggedInRoute;
